import React, { Dispatch, useEffect, useState, useCallback } from 'react';
import '../../App.css';
import _ from 'lodash';
import { logout, setUserId } from '../../features/auth/authSlice'
import { fetchUser } from '../../features/user/userSlice'
import { useNavigate } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { IScenario, ISelectedOption, IInjectInfo, IGameStatus, IHotwash } from '../../interfaces';
import type { RootState } from '../../store'

import Modal from 'react-modal';
import {parseJwt} from "../../helpers/helperFunctions";

interface HeaderProps {
    selectedScenario: IScenario;
    injectItem: IInjectInfo;
    setSelectedScenario: Dispatch<any>;
    currentGame: IGameStatus;
    isHost: boolean;
    hotwashStatus: IHotwash;
    updateHotwashStatus: Dispatch<any>;
    zoomLevel: number;
    intervalHandler: (command: string, gameId: string, inGame: boolean) => void;
    gameId: string | null;
    onNavTimeline: () => {};
  }

Modal.setAppElement('#root');

const HotwashHeader: React.FC<HeaderProps> = ({ setSelectedScenario, selectedScenario, injectItem, currentGame, isHost, hotwashStatus, updateHotwashStatus, zoomLevel, intervalHandler, gameId, onNavTimeline }) => {
    
    const { accessToken } = useAppSelector((state: RootState) => state.auth)
    const [intervalHandle, setIntervalHandle] = useState<any>('')

    const hotwashIntervalHandler = useCallback((command: string, gameId: string | null) => {
        if (command === "start") {
          if (!isNaN(intervalHandle)) {
            clearInterval(intervalHandle)
          }
          setIntervalHandle(setInterval(() => {
            if (!_.isEmpty(gameId)) {
                updateHotwashStatus(gameId)
            }
          }, 3000));
        }
    
        if (command === "stop") {
            clearInterval(intervalHandle)
        }
      }, [intervalHandle, setIntervalHandle]); // eslint-disable-line react-hooks/exhaustive-deps
    
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    let [loggedIn, setLoggedIn] = useState<boolean>(false);
    let [userInfo, setUserInfo] = useState<any>({});

    useEffect(() => {
        const getUserInfo = async (id: string) => {
            let user: any = await dispatch(fetchUser(id))
            if (user.payload === undefined || user.error !== undefined) {
                dispatch(logout())
                setLoggedIn(false)
            } else {
                setUserInfo(user.payload)
                dispatch(setUserId());
                setLoggedIn(true)
            }
        }

        intervalHandler("stop", "", false)
        
        if (accessToken) {
            hotwashIntervalHandler("start", gameId)
            let parsedJWT = parseJwt(accessToken)
            getUserInfo(parsedJWT.id)
            dispatch(setUserId());
        } else {
          setLoggedIn(false)
          navigate('/login')
        }
      }, [navigate, accessToken, dispatch, setLoggedIn]) // eslint-disable-line react-hooks/exhaustive-deps

    const clickLogout = (ev: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(logout())
        setLoggedIn(false)
    }

    const options: ISelectedOption[] = [];
 
    for (let i = 0; i<selectedScenario.gameTimeInterval; i++) {
        options.push({ value: (i+1).toString(), label: (i+1).toString() })
    }

    return (
        <header className="txp-sc-header hotwash-hdr">
          <div onClick={() => window.location.replace('/player') } className="header-logo-link">
            <img className="txp-sc-logo-icon" src="img/txp-build-logo.svg" alt="logo" />
            <div className="txp-sc-title">TXP</div>
          </div>
            
            {!_.isEmpty(selectedScenario.id) ?
            <div className="scenario-leader" onClick={onNavTimeline} style={{cursor: 'pointer'}}>
                <div className="scenario-leader-label">
                Scenario
                </div>
                <div className="scenario-leader-title">
                {_.isEmpty(selectedScenario.name) ? 'Unnamed Scenario' : selectedScenario.name}
                </div>
            </div> : <></>} 

            {!_.isEmpty(injectItem.injectId) ? <div className="scenario-leader">
                    <img src="img/chevron-right-blue.svg" className="chevron-right-blue" alt="icon" />
                    <div className="scenario-leader-content">
                        <div className="scenario-leader-label">
                        Inject
                        </div>
                        <div className="scenario-leader-title">
                        {injectItem.name}
                        </div>
                    </div>
                    </div> : <></> }

                    <div className='header-status hotwash-header'>
                    <div className="header-info">
                        <div className="header-icon">
                            <img src="img/person.svg" alt="person" className="header-info-person" />
                        </div>
                        <div className="header-info-list">
                            
                            {loggedIn ? 
                                <div className="header-info-item header-username">
                                    <img src="img/person.svg" className="header-info-icon" alt="user" />
                                    <div className="header-info-id">{userInfo.email}</div>
                                </div>
                            : ''}
                            
                            <div className="header-info-item">
                                <img src="img/logout.svg" className="header-info-icon" alt="logout" />
                                <button className='logout-link' onClick={clickLogout}>
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            <div className="hotwash-header-btns">
              <button className="hotwash-header-exit" onClick={() => window.location.replace('/player') }>Exit <img src="/img/white-x.svg" alt="x" /></button>
            </div>
        </header>
    );
}

export default HotwashHeader